import { AfterViewInit, Directive } from '@angular/core';
import { MatSelect } from '@angular/material/select';

// Opens a mat-select as soon as it is created (used by lazily created selects)
@Directive({
  selector: 'mat-select[appAutoOpenSelect]',
})
export class AutoOpenSelectDirective implements AfterViewInit {
  constructor(private select: MatSelect) {}

  ngAfterViewInit(): void {
    Promise.resolve().then(() => this.select.open());
  }
}
